import { env } from '@/config/env'

/**
 * Facebook Messenger deep link.
 *
 * One of the two support chat handoffs (see `whatsapp.js` for the other).
 * Ordering happens on-site through /checkout — the old wa.me checkout flow is
 * gone; chat is support only.
 *
 * Callers should pass `messengerPageId` from `useSettings()`, which is the
 * value the owner controls at /admin/settings. The env default remains only so
 * this never builds `m.me/undefined` if someone calls it bare — it is the
 * build-time fallback, not the source of truth.
 *
 * @param {string} [pageId]
 */
export function messengerUrl(pageId = env.messengerPageId) {
  return `https://m.me/${pageId}`
}
